export const LOCAL_STORAGE_VERSION = 1
export const DEFAULT_INDEX_DECIMALS = 18
export const DEFAULT_NATIVE_DECIMALS = 18
export const BASE = 10
export const BASE_POINT = 10000
export const ALL_PORTFOLIO_ID = '0x0'
export const DEFAULT_DECIMAL_DISPLAY_POSITION = 2
export const SAVAX_APY = '7'
export const DEFAULT_NETWORK = 1
//Mint whitelist assets for select
export const MINT_WHITELIST = ['USDC', 'WETH']

// Head tag constants
export const BASE_META_DESCRIPTION =
  'Invest, buy and sell Phuture index funds through our app. Accessible to anyone, anywhere. Upgrade your investment strategy with our crypto index funds.'
export const APP_URL = 'https://app.phuture.finance'

// social media links
export const PrivacyLinks: {
  link: string
  name: string
}[] = [
  { link: '/terms-and-conditions', name: 'Terms & conditions' },
  { link: '/privacy-policy', name: 'Privacy Policy' },
]

export const STAKING_ROUTER_ADDRESS = '0x57136542BdC53aaf53bF519a6D28A6C8F7CEEB1c'
export const ZERO_EX_AFFILIATE_BASE_ADDRESS = '0x7f3823c4C8e3e70f2932e2AcE7A6e8f4A598E5d2' //JMX
export const ZERO_EX_AFFILIATE_AVAX_ADDRESS = '0x4c2733AB3F8B09794dCb5025CBAe9bdA6807ddc9' //CAI

export const STORAGE_VERSION = '1.5'

export const WAD = 1000000000000000000n
